import service from '@/utils/request'; // @Tags BairunSvcDiscount
// @Summary 创建BairunSvcDiscount
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcDiscount true "创建BairunSvcDiscount"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /BairunSvcDiscount/createBairunSvcDiscount [post]

export var createBairunSvcDiscountPrice = function createBairunSvcDiscountPrice(data) {
  return service({
    url: '/svcManage/svcDiscountPrice/create',
    method: 'post',
    data: data
  });
}; // @Tags BairunSvcDiscount
// @Summary 删除BairunSvcDiscount
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcDiscount true "删除BairunSvcDiscount"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /BairunSvcDiscount/deleteBairunSvcDiscount [delete]

export var deleteBairunSvcDiscountPrice = function deleteBairunSvcDiscountPrice(data) {
  return service({
    url: '/svcManage/svcDiscountPrice/delete',
    method: 'post',
    data: data
  });
}; // @Tags BairunSvcDiscount
// @Summary 删除BairunSvcDiscount
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除BairunSvcDiscount"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /BairunSvcDiscount/deleteBairunSvcDiscount [delete]

export var deleteBairunSvcDiscountPriceByIds = function deleteBairunSvcDiscountPriceByIds(data) {
  return service({
    url: '/svcManage/svcDiscountPrice/deleteByIds',
    method: 'post',
    data: data
  });
}; // @Tags BairunSvcDiscount
// @Summary 更新BairunSvcDiscount
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcDiscount true "更新BairunSvcDiscount"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /BairunSvcDiscount/updateBairunSvcDiscount [put]

export var updateBairunSvcDiscountPrice = function updateBairunSvcDiscountPrice(data) {
  return service({
    url: '/svcManage/svcDiscountPrice/update',
    method: 'put',
    data: data
  });
}; // @Tags BairunSvcDiscount
// @Summary 用id查询BairunSvcDiscount
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcDiscount true "用id查询BairunSvcDiscount"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /BairunSvcDiscount/findBairunSvcDiscount [get]

export var findBairunSvcDiscountPrice = function findBairunSvcDiscountPrice(params) {
  return service({
    url: '/svcManage/svcDiscountPrice/find',
    method: 'get',
    params: params
  });
}; // @Tags BairunSvcDiscount
// @Summary 分页获取BairunSvcDiscount列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取BairunSvcDiscount列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /BairunSvcDiscount/getBairunSvcDiscountList [get]

export var getBairunSvcDiscountPriceList = function getBairunSvcDiscountPriceList(params) {
  return service({
    url: '/svcManage/svcDiscountPrice/getList',
    method: 'get',
    donNotShowLoading: params.donNotShowLoading ? params.donNotShowLoading : true,
    params: params
  });
};